module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side"
  }, [_c('el-menu', {
    attrs: {
      "default-active": "/",
      "router": "",
      "theme": "dark"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("弹幕查询")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/statistics"
    }
  }, [_vm._v("月度弹幕统计")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/statistics/day"
    }
  }, [_vm._v("每日弹幕统计")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4e89e12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/side.vue
// module id = 489
// module chunks = 1